export { default as GDMFarmerRegisterForm } from './GDMFarmerRegisterForm';

export type {
  GDMFarmerRegisterFormComponent,
  GDMFarmerRegisterFormProps,
} from './GDMFarmerRegisterForm.type';
